export const offers = [
    {
        id: 1,
        title: "Cold & flu",
        details: [
            "Cough",
            "Headaches",
            "Nausea & vomiting",
            "Fever",
        ]
    },
    {
        id: 2,
        title: "Mental health",
        details: [
            "Cough",
            "Headaches",
            "Nausea & vomiting",
            "Fever"
        ]
    },
    {
        id: 3,
        title: "Mental health",
        details: [
            "Cough",
            "Headaches",
            "Nausea & vomiting",
            "Fever"
        ]
    },
    {
        id: 4,
        title: "Headaches",
        details: [
            "Cough",
            "Headaches",
            "Nausea & vomiting",
            "Fever"
        ]
    },
    {
        id: 5,
        title: "Everyday care",
        details: [
            "Cough",
            "Headaches",
            "Nausea & vomiting",
            "Fever"
        ]
    },
    {
        id: 6,
        title: "Allergies",
        details: [
            "Cough",
            "Headaches",
            "Nausea & vomiting",
            "Fever"
        ]
    }
];